import React from "react";
import {
  Card,
  CardHeader,
  CardBody,
  FormGroup,
  Form,
  Input,
  Badge,
  Row,
  Col,
  Button,    
} from "reactstrap";
import {
   Link
} from "react-router-dom";

// core components
import PanelHeader from "components/PanelHeader/PanelHeader.jsx";
import Select from "react-dropdown-select";
import {provisioners, provisionerService} from '../../settings/shared/constants'
import { toast } from 'react-toastify';
// import { toast } from '../../settings/shared/constants';
import ProvisionerService from "../../services/api/Provisioner";
import ClusterService from '../../services/api/Cluster'
import ScaleLoader from "react-spinners/ScaleLoader";
import LoadingOverlay from 'react-loading-overlay'
import 'react-confirm-alert/src/react-confirm-alert.css'; // Import css
// import RangeSlider from 'react-bootstrap-range-slider';
// import 'react-bootstrap-range-slider/dist/react-bootstrap-range-slider.css';
import googlelogo from "assets/img/google.png";
import azurelogo from "assets/img/azure.png";
import awslogo from "assets/img/aws.png";
import { Scrollbars } from 'react-custom-scrollbars';


const agingpolicyoption = [
  { label: "Terminate", value: "TERMINATE" },
  { label: "Never", value: "NEVER" },
]; 

const styles = {
  errorBox:{
    textAlign:"center",
    marginBottom:20
  },
  error:{
    color: "rgb(255, 0, 0)",
    fontSize: 13,
    backgroundColor: "rgb(249, 228, 228)",
    padding: "6px 200px 6px 250px",
    borderRadius:6
  },
  passwordHint:{
    color:"#000",
    fontSize:12
  },
  rowAlign: {
    marginTop: 28
  },
}
class Create extends React.Component {

  constructor(props) {
    super(props)     
    this.state = { 
    isGoogle:false,
    errorSubmitted:false,
    mode:'',
    cname:'',
    errorMessage:'',
    editid:'',
    lockstatus:false,
    editFlag:false,
    cruntimeimage:'',
    zoneValue:'',
    computeInstanceValue:'',
    computeinstarray:[],
    zone:[],
    agingpolicyValue:'TERMINATE',
    selectruntimeimage:'',
    provisionerDTOS:[],
    nodes:1,
    minnodes:1,
    maxnodes:1,
    idlesecs:'',
    idleevenarray:[],
    standardcpuvalue:0,
    standardramvalue:0,
    gpucpuvalue:0,
    gpuramvalue:0,
    standardcpuarray :[30,50,64,87,100],
    standardramarray:[130,150,164,187,190],
    gpucpuarray:[2,4,8,16,20],
    gpuramarray:[45,65,70,80,100],
    ppl:[],
    provisionerId: '',
    autoscaling:false,
    avaliabletype:'',
    swidth: window.innerWidth,
    sheight: window.innerHeight
   
  }
  this.handlestandardcpu = this.handlestandardcpu.bind(this);
  this.handlestandardram = this.handlestandardram.bind(this);
  this.handlegpucpu = this.handlegpucpu.bind(this);
  this.handlegpuram = this.handlegpuram.bind(this);
  this.updateWindowDimensions = this.updateWindowDimensions.bind(this);

  
      // this.state.selectruntimeimage = [
      //   { label: <div><img src={googlelogo} style={{ width: '16px', height: '16px' }}></img> &nbsp;Google </div>, value: "Google" },
      //   { label: <div><img src={azurelogo} style={{ width: '20px', height: '18px' }}></img> &nbsp;Azure </div>, value: "Azure" },
      //   { label: <div><img src={awslogo} style={{ width: '22px', height: '22px' }}></img> &nbsp;AWS </div>, value: "AWS" },
      //   { label: <div><img src={vmwarelogo} style={{ width: '23px', height: '23px' }}></img> &nbsp;VMware </div>, value: "VMware" },
      //   { label: <div><img src={baremetallogo} style={{ width: '23px', height: '23px' }}></img> &nbsp;Bare Metal </div>, value: "Bare Metal" },
      // ];   
}

 componentDidMount() {
  this.GetAllProvisioners();
  this.idleEven();
  this.updateWindowDimensions();
  window.addEventListener('resize', this.updateWindowDimensions);

  }
  componentWillUnmount() {
    window.removeEventListener('resize', this.updateWindowDimensions);
  }
  
  updateWindowDimensions() {
    this.setState({ swidth: window.innerWidth, sheight: window.innerHeight});
  }
  idleEven() {

    const ppl = [];
    let num = 80
   for (let i=1; i<num; i++) {
     if(i % 2 === 0) {
      ppl.push({
        label: i,
        value: i
    });
     this.state = {ppl}
     }      
   }
   const er = this.state.ppl.map((item, index) => {
    return(
    { label: item.label, value: item.value}
    )
    }) 
    this.setState({loading:false,idleevenarray: er}) ;

 }
 
  GetAllProvisioners = () => {
    this.setState({ loading: true });
    ProvisionerService.getProvisionerByService(provisionerService.kubernetesCluster).then(response => {
      if (response.status === 'SUCCESS') {
        let provisionerDetails = response.provisionerDTOPage.content;
        const er = provisionerDetails.map((item, index) => {
          const provisionerType = item.provisionerType;
          this.state.badgestate = "bg-success"
          this.state.cloudType = provisionerType
          if (provisionerType === provisioners.aws) {
            this.state.logotype = <img src={awslogo} style={{ width: '16px', height: '16px' }} alt="" ></img>
          } else if (provisionerType === provisioners.azure) {
            this.state.logotype = <img src={azurelogo} style={{ width: '16px', height: '16px' }} alt="" ></img>
          } else if (provisionerType === provisioners.google) {
            this.state.logotype = <img src={googlelogo} style={{ width: '16px', height: '16px' }} alt="" ></img>
          }
          return (
            {
              label: <div id={item.id}><Badge color="" className="badge-dot"><i className={this.state.badgestate} /></Badge> {this.state.logotype} &nbsp;{item.name} </div>,
              value: item.name,
              id: item.id,
              name: this.state.cloudType
            }
          )
        })
        this.setState({ loading: false, provisionerDTOS: er });
      }
    })
  }

  handlestandardcpu = e => {
    this.setState({ standardcpuvalue: e.target.value });
  };
  handlestandardram = e => {
    this.setState({ standardramvalue: e.target.value });
  };
  handlegpucpu = e => {
    this.setState({ gpucpuvalue: e.target.value });
  };
  handlegpuram = e => {
    this.setState({ gpuramvalue: e.target.value });
  };
  /* To get Input Text */
  handleChange = (event) => {
    event.preventDefault();
    const { name, value } = event.target;
    this.setState({ [name]: value});
  }
  handleCPUChange= (event) => {
    event.preventDefault();
    const { name, value } = event.target;
    this.setState({ cpuvalue: value});
  }

  /* To get Number of nodes */
  numberofnodesChange = e => {
    // this.setState({ nodes: e.target.value , minnodes:e.target.value});
    this.setState({ nodes: e.target.value});

  };

  minnodesChange = (event) => {
    const { name, value } = event.target;
    if(value > 256){
      this.setErrorMessage("Min Nodes should be less than 256");
  }
  else{
    this.setErrorMessage("");
  }
    this.setState({ [name]: value, minnodes:value,maxnodes:parseInt(value)+1});
  }
  maxnodesChange = (event) => {
    const { name, value } = event.target;
    if(value > 256){
      this.setErrorMessage("Max Nodes should be less than 257");
  }
  else{
    this.setErrorMessage("");
  }
    this.setState({ [name]: value, maxnodes:value});
  }



  /* To get Cluster Provider */
  handleChangeProvisioner = (event) => {
    this.state.cruntimeimage=event[0].value;
    this.state.provisionerId = event[0].id;
    this.state.providertype = event[0].name;
    ClusterService.getMachineTypes(this.state.providertype)
    .then((response) => {
        this.state.computeArray = response.machineTypeDTO.machineTypes;
        this.state.zoneArray = response.machineTypeDTO.zones;
    let zones = this.state.zoneArray
    const zoneArrayValue = zones.map((item, index) => {
      return(
        { label:item.name , value:item.availableTypes}
        )
    }) 
    this.setState({loading:false,zone: zoneArrayValue}) ;
})

  }
   /* To get Zone */
   handleChangeZone = (event) => {
     this.state.zoneValue = event[0].label;
     this.state.avaliabletype = event[0].value;
    this.setState({zoneValue:event[0].label,avaliabletype: event[0].value});
     let selectedInstances = []
     let zoneTypes = this.state.avaliabletype
     let computeInstanceArray = this.state.computeArray
     zoneTypes.forEach(element => {
      computeInstanceArray.map((item, index) => {
        if(element === item.type) {
          selectedInstances.push(item)
        }
      });
     });    
       const computearrayfilter = selectedInstances.map((item, index) => {
        return(
         { label:<div>{item.label} <code><b>vCPUs- </b></code><b>{item.vCPUs}</b> <code><b>Memory- </b></code><b>{item.memory}</b></div>, value: item.name, type:item.type }
         ) 
        })
        this.setState({loading:false,computeinstarray:computearrayfilter}) 
  }

  /* To get AutoScaling */
  handleAutoScaling = (event) => {
    this.setState({
      autoscaling: event.target.checked
    })
  }


  /* To get Aging Policy */
  handleChangeAgingSelect = (event) => {
       this.setState({ agingpolicyValue: event[0].value });
  }
 /* To get Compute Instance */
 getComputeInstance = (event) =>{
  this.setState({ computeInstanceValue: event[0].value });
  }
  /* To get Idle Secs */
  handleIdleSelect = (event) => {
    this.setState({ idlesecs: event[0].value });
    }
  onDismiss = () => { };
  cancelClick = () =>{
      this.props.history.push('/cluster/all/');    
    }
  setErrorMessage(message){
      if(message === ""){
        this.setState({
          errorMessage:message,
          errorSubmitted:false
        })
      }else{
     document.getElementById('errorDiv').scrollIntoView()
      this.setState({
        errorMessage:message,
        errorSubmitted:true
      });
      }
   }
     // Submit Engine Data
  CreateNewEngine = (event) => {
   event.preventDefault();
    if((this.state.cname === "" || this.state.cname === undefined)){
        this.setErrorMessage("Please Enter Name");
    } else if(this.state.cdescription === ""){
      this.setErrorMessage("Please Type some Description");
    } else if(this.state.cruntimeimage === ""){
        this.setErrorMessage("Please Select a Cluster Provider");
    } else if(this.state.zoneValue === ""){
      this.setErrorMessage("Please Select a Zone");
    } else if(this.state.computeInstanceValue === ""){
    this.setErrorMessage("Please Select a Compute Instance");
    }  else if(this.state.nodes === ""){
      this.setErrorMessage("Please Select a Number of Nodes");
    } 
    else if(this.state.nodes < 1 || this.state.nodes > 15){
      this.setErrorMessage("Node count should be between 1 to 15.");
    } 
    // else if(this.state.autoscaling === true){
    //    if(this.state.minnodes ==""){
    //     this.setErrorMessage("Please Select a MinInstance");
    //     } else if(this.state.maxnodes ==""){
    //       this.setErrorMessage("Please Select a MaxInstance");
    //     } 
    //     else{
    //       this.setErrorMessage("");
    //     }
    // }
   else if(this.state.agingpolicyValue === ""){
    this.setErrorMessage("Please Select a Aging Policy");
  }
  else{
         this.setErrorMessage("");
          if(!this.state.errorSubmitted) {    
            let post ={}
            if(this.state.cruntimeimage ===  "GOOGLE_ENGINE_TYPE"){
              this.state.cruntimeimage = "Google"
            }
              post ={
                agingPolicy:this.state.agingpolicyValue,
                computeInstance:this.state.computeInstanceValue,
                description:this.state.cdescription,
                idleSecs:this.state.idlesecs,    
                maxInstance:parseInt(this.state.maxnodes),
                minInstance:parseInt(this.state.minnodes),
                name:this.state.cname,
                nodeCount:this.state.nodes,
                provisionerId:this.state.provisionerId,       
                zone:this.state.zoneValue,
            }
        
          
              // console.log('CreateNewEngine',JSON.stringify(post));
                ClusterService.addNewCluster(post)
                .then((response) => {
                    if (response.status === 'SUCCESS') {
                    toast.success(<i className="fas fa-check-circle">&nbsp; <b className="toast-txt">Cluster Created Successfully!</b></i>); 
                    this.props.history.push('/cluster/all/');    
                    this.clearformData();   // Reset Form data    
                    } else {
                    // toast.error(response.errorMessage);
                    this.setErrorMessage("Error in Creating Cluster");
                    // this.clearformData();   // Reset Form data    
                    }
                }
                );
          }else{
          console.error('Invalid Form')
           }
      }  
  }

  // Reset form data
  clearformData(){
    this.setState({
      cname:'',
      cdescription:'',
      cruntimeimage:'',
      zoneValue:'',
      computeInstanceValue:'',
      minnodes:'',
      maxnodes:'',
      // agingpolicyValue:''
    })
  }


  render() {
    return (
   
      <>
      <PanelHeader
          content={
            <div className="header text-center">
            
            </div>
          }
        />
        <div className="content">
        <Row>
        <Col xs={12} md={12}>
        <Card>
          <CardBody>
                  <div className="carcontent">
                  <LoadingOverlay
     active={this.state.loading}
     spinner={<ScaleLoader
       height={35}
       width={5}
       radius={2}
       margin={2}
       color={"#123abc"}
       loading={this.state.loading}
      />}
    >
          <Row>
            <div className=" col" id="errorDiv">
                <CardHeader> 
                  <Row className="align-items-center">
                    <div className="col">
                     <h5 className="mb-0">New Cluster</h5>
                    </div>
                    <div className="col text-right">
                    <Link to="/cluster/all/" >
                      <span className="close clear-filter">×</span>                     
                    </Link>
                     
                    </div>
                  </Row>
                </CardHeader>
                <Scrollbars autoHeight autoHeightMin={this.state.sheight-180}>

                    {this.state.errorSubmitted &&
                    <div style={styles.errorBox}>
                    <span style={styles.error}>{this.state.errorMessage}</span>
                    </div>
                    }
             
                  <Form onSubmit={this.CreateNewEngine} noValidate >  
                     <div className="pl-lg-4">
                      <Row>
                          <Col lg="6">
                          <FormGroup>
                            <label
                              className="form-control-label"
                              htmlFor="input-email"
                            >
                            Cluster Name
                            </label>
                            <Input
                          className="form-control"
                          placeholder="Name"
                          name="cname"
                          value={this.state.cname}
                          type="text"
                          onChange={this.handleChange}/>
                          </FormGroup>
                        </Col>  
                        <Col lg="6">
                          <FormGroup>
                            <label
                              className="form-control-label"
                              htmlFor="input-email"
                            >
                            Description
                            </label>
                            <Input
                                className="form-control-alternative"
                                placeholder="Description"
                                rows="4"
                                name="cdescription"
                                value={this.state.cdescription}
                                type="textarea"
                                onChange={this.handleChange} noValidate/>
                          </FormGroup>
                        </Col>                   
                      </Row>
                      <Row>
                       <Col lg="12">
                          <FormGroup>  
                              <label
                                className="form-control-label"
                                htmlFor="input-username"
                              >
                                Cluster Provisioner
                              </label>

      <Select className="form-control" name="runtimeimage" values={this.state.provisionerDTOS.filter(item => item.value === this.state.provisionerDTOS)}
       id={this.state.provisionerDTOS.filter(item => item.id === this.state.provisionerDTOS)} options={this.state.provisionerDTOS} onChange={this.handleChangeProvisioner} noValidate />
                            </FormGroup>
              
                        </Col>
                      </Row>
                      <Row>
                      <Col lg="12">
                          <FormGroup>  
                              <label
                                className="form-control-label"
                                htmlFor="input-username"
                              >
                                Zone
                              </label>
                              <Select className="form-control" name="zone" 
                              values={this.state.zone.filter(item => item.label === this.state.zoneValue)}
                              onChange={this.handleChangeZone} options={this.state.zone} noValidate>
                              </Select>
                            </FormGroup>
                        </Col>
                                             
                      </Row>
                      <Row> 
                       <Col lg="12">
                          <FormGroup>
                            <label
                              className="form-control-label"
                              htmlFor="input-email"
                            >
                            Compute Instance
                            </label>
                            <Select className="form-control" name="ComputeInstance" 
                               values={this.state.computeinstarray.filter(item=>item.value === this.state.computeInstanceValue)}
                              onChange={this.getComputeInstance} options={this.state.computeinstarray} noValidate>
                            </Select>
                            {/* <div className="checkbox-radios col-sm-10">
                            <div className="form-check-radio form-check">
                              <label className="form-check-label">
                                <input id="Standard" name="ComputeInstance" type="radio" className="form-check-input" value="Standard" onChange={this.getComputeInstance}/>
                                <span className="form-check-sign"></span>Standard</label> &nbsp;
                                <label className="form-check-label">
                                <input id="GPU" name="ComputeInstance" type="radio" className="form-check-input" value="GPU" onChange={this.getComputeInstance}/>
                                <span className="form-check-sign"></span>GPU</label>
                                </div>
                                </div> 
                        */}
                       
                       
                       
                          </FormGroup>
                        </Col> 
                        </Row>
                        {/* {this.state.computeInstanceValue === "Standard" &&  <Row>
                        <Col lg="6">
                          <label className="label-on-right col-form-label"><code>CPU : <b className="text-info">{this.state.standardcpuarray[this.state.standardcpuvalue]} CPU</b> </code>
                          </label>
                          <div>
                          <input
          onChange={this.handlestandardcpu}
          type={"range"}
          min={0}
          defaultValue={0}
           max={4}
          step={1}
          list={"stdcpulist"}
        />
        <datalist id="stdcpulist">
       {this.state.standardcpuarray.map((item, key) =>
      <option key={key} value={item} />
    )} 
        </datalist>
      </div>
      </Col>
       <Col lg="6">
      <label className="label-on-right col-form-label"><code>RAM : <b className="text-info">{this.state.standardramarray[this.state.standardramvalue]} RAM</b></code></label> 
      <div>
        <input
          onChange={this.handlestandardram}
          type={"range"}
          min={0}
          defaultValue={0}
          max={4}
          step={1}
          list={"stdramlist"}
        />
        <datalist id="stdramlist">
        {this.state.standardramarray.map((item, key) =>
      <option key={key} value={item} />
    )}
        </datalist>
      </div>
     </Col>
      </Row>
                        }
                        {this.state.computeInstanceValue === "GPU" &&  <Row>       
        <Col lg="6">
             <label className="label-on-right col-form-label"><code>CPU : <b className="text-info">{this.state.gpucpuarray[this.state.gpucpuvalue]} CPU</b></code></label>
              <div>
                <input
          onChange={this.handlegpucpu}
          type={"range"}
          defaultValue={0}
          min={0}
          max={4}
          step={1}
          list={"gpucpulist"}
        />
        <datalist id="gpucpulist">
        {this.state.gpucpuarray.map((item, key) =>
      <option key={key} value={item} />
    )}
        </datalist>
      </div>
          </Col>
          <Col lg="6">
          <label className="label-on-right col-form-label"><code>RAM : <b className="text-info">{this.state.gpuramarray[this.state.gpuramvalue]} RAM</b></code></label> 
<div>
                          <input
          onChange={this.handlegpuram}
          type={"range"}
          defaultValue={0}
          min={0}
          max={4}
          step={1}
          list={"gpuramlist"}
        />
        <datalist id="gpuramlist">
        {this.state.gpuramarray.map((item, key) =>
      <option key={key} value={item} />
    )}
        </datalist>
      </div>
          </Col>
                    </Row>
                        } */}
                        <Row> 
                       <Col lg="12">
                          <FormGroup>
                            <label
                              className="form-control-label"
                              htmlFor="input-email"
                            >
                            Number of Nodes
                            </label>
                            <Input
                          className="form-control"
                          placeholder="Number of Nodes"
                          name="nodes"
                          value={this.state.nodes}
                          type="number"
                          min="1"
                          max="15"
                          onKeyDown={ (evt) => evt.key === 'e' && evt.preventDefault() } 
                          onChange={this.numberofnodesChange}
                          />
                          </FormGroup>
                        </Col> 
                        </Row>

                        <Row> 
                       <Col lg="12">
                        <FormGroup>
                         <div className="custom-control custom-checkbox">
                         <input type="checkbox" className="custom-control-input" id="EnableAutoscaling" onChange={this.handleAutoScaling} checked={this.state.autoscaling}/>
                          <label className="custom-control-label" > Enable Autoscaling</label>
                         </div>
                        </FormGroup>
                        </Col> 
                        </Row>
                        {this.state.autoscaling === true &&
                        <Row>
                       <Col lg="6">
                         <div style={{padding: '0px 0px 0px 35px'}}> 
                        <FormGroup>
                          <label
                              className="form-control-label"
                              htmlFor="input-email"
                            >
                            Minimum Number of Nodes
                            </label>
                            <Input
                          className="form-control"
                          placeholder="Minimum Number of Nodes"
                          name="minnodes"
                          value={this.state.minnodes}
                          type="number"
                          min={this.state.nodes}
                          max="15"
                          onKeyDown={ (evt) => evt.key === 'e' && evt.preventDefault() } 
                          onChange={this.minnodesChange}
                          />
                          </FormGroup>
                          </div>
                        </Col> 
                       <Col lg="6">
                       <div style={{padding: '0px 0px 0px 35px'}}> 
                          <FormGroup>
                            <label
                              className="form-control-label"
                              htmlFor="input-email"
                            >
                            Maximum Number of Nodes
                            </label>
                            <Input
                          className="form-control"
                          placeholder="Maximum Number of Nodes"
                          name="maxnodes"
                          value={this.state.maxnodes}
                          type="number"
                          min={this.state.minnodes}
                          max="256"
                          onKeyDown={ (evt) => evt.key === 'e' && evt.preventDefault() } 
                          onChange={this.maxnodesChange}
                          />
                          </FormGroup>
                        </div>
                        </Col> 
                      </Row>
  }




{/* 
                      <Row>
                      <Col lg="6">
                          <FormGroup>
                            <label
                              className="form-control-label"
                              htmlFor="input-email"
                            >
                            Min # Instance
                            </label>
                            <Input
                          className="form-control"
                          placeholder="Min # Instance"
                          name="mininstance"
                          value={this.state.mininstance}
                          type="number"
                          min="1"
                          max="256"
                          onKeyDown={ (evt) => evt.key === 'e' && evt.preventDefault() } 
                          onChange={this.mininstanseChange}
                          />
                          </FormGroup>
                        </Col> 
                        <Col lg="6">
                          <FormGroup>
                            <label
                              className="form-control-label"
                              htmlFor="input-email"
                            >
                            Max # Instance
                            </label>
                            <Input
                          className="form-control"
                          placeholder="Max # Instance"
                          name="maxinstance"
                          value={this.state.maxinstance}
                          type="number"
                          min={this.state.mininstance}
                          max="256"
                          onKeyDown={ (evt) => evt.key === 'e' && evt.preventDefault() } 
                          onChange={this.maxinstanseChange}/>
                          </FormGroup>
                        </Col> 
                      </Row>
                      */}
                      <Row>
                          <Col lg="6">
                          <FormGroup>
                            <label
                              className="form-control-label"
                              htmlFor="input-email"
                            >
                            Aging Policy
                            </label>
                            <Select className="form-control" name="agingpolicy" options={agingpolicyoption} 
                              values={agingpolicyoption.filter(item=>item.value === this.state.agingpolicyValue)}
                              onChange={this.handleChangeAgingSelect} />

                          </FormGroup>
                        </Col> 
                       
                        <Col lg="4">
                        {this.state.agingpolicyValue === "TERMINATE" &&
                        <div>
                          <FormGroup>
                            <label
                              className="form-control-label"
                              htmlFor="input-email"
                            >
                            If Idle
                            </label>
                            <Select className="form-control" name="Idle" values={this.state.idleevenarray.filter(item => item.value === this.state.idlesecs)}
       options={this.state.idleevenarray} onChange={this.handleIdleSelect} noValidate />
                          </FormGroup>                         
                               
                        </div>  
                      }
                       
                      </Col>
                      <Col lg="2">
                      {this.state.agingpolicyValue === "TERMINATE" &&
                        <div>
                      <br></br>
                        <label className="label-on-right col-form-label"><code>Hours</code></label> 
                      </div>
                      }
                      </Col>
                
                      </Row>    
                     </div>                
                    <hr className="my-4" />
                     <Row className="stickybuttons">  
                     <Col lg="1">
                    <FormGroup>
                    <Button
                       color="secondary"
                       size="sm"
                       type="submit"
                       onClick={this.cancelClick}
                     >
                       Cancel
                     </Button>
                    </FormGroup>
                     </Col>
                     <Col lg="2">
                    <FormGroup>
                      <Button
                       color="primary"
                       size="sm"
                       type="submit"
                     // onClick={this.CreateNewEngine}
                     >
                       Create Cluster
                     </Button>
                     </FormGroup>
                     </Col>
                     </Row>
                   </Form>
                </Scrollbars>
                {/* </CardBody>
              </Card> */}
            </div>
          </Row>
          </LoadingOverlay>

          </div>

       </CardBody>
       </Card>
        </Col>
        </Row>
        </div>
      </>
    );
  }
}

export default Create;
